import type { ReactNode, TdHTMLAttributes } from "react";

type TdAttrs = TdHTMLAttributes<HTMLTableCellElement>;

type GridTdProps = TdAttrs & {
	/**
	 * The `tdProps` Kendo passes to a custom cell renderer. May contain a
	 * `key` property at runtime, which React 19 forbids when spread.
	 */
	tdProps?: TdAttrs | null;
	children?: ReactNode;
};

/**
 * Renders the `<td>` for a Kendo custom cell renderer while safely passing
 * `key` separately from the spread props (React 19 disallows spreading `key`).
 *
 * Usage:
 * ```tsx
 * <GridTd tdProps={props.tdProps}>{value}</GridTd>
 * ```
 */
export const GridTd = ({ tdProps, children, ...rest }: GridTdProps) => {
	const { key, ...spread } = (tdProps ?? {}) as TdAttrs & {
		key?: React.Key | null;
	};

	return (
		<td key={key ?? undefined} {...spread} {...rest}>
			{children}
		</td>
	);
};
